import React from "react";
import { Colours } from "../../utils/colours";
import IntroCircleImageAndSearch from "./IntroCircleImageAndSearch/IntroCircleImageAndSearch";
import IntroHeroLeftAligned from "./IntroHeroLeftAligned";
import IntroHeroWithImage from "./IntroHeroWithImage";
import IntroHeroWithImageRight from "./IntroHeroWithImageRight/IntroHeroWithImageRight";
import IntroHeroWithPreHeading from "./IntroHeroWithPreHeading";
import IntroHeroWithSubheading from "./IntroHeroWithSubheading";
import IntroOurStories from "./IntroOurStories/IntroOurStories";
import IntroRehoming from "./IntroRehoming";
import IntroSponsorADogSearch from "./IntroSponsorADogSearch";
import { getBorderColour } from "./IntroToDisplay.utils";
import IntroWithImageTeal from "./IntroWithImageTeal";

export type IntroType = "Intro-Rehoming";
export interface IntroProps {
	introType:
		| "Intro-Rehoming"
		| "Intro-Hero-With-Image"
		| "Intro-Hero-With-Image-Right"
		| "Intro-Hero-With-Image-Teal"
		| "Intro-Hero-With-Pre-Heading"
		| "Intro-Hero-With-Sub-Heading"
		| "Intro-Hero-Left-Aligned"
		| "Intro-Circle-Image-And-Search"
		| "Intro-Sponsor-Dog-Search"
		| "Intro-With-Icons-Teal"
		| "Intro-OurStories";
	preHeading?: string;
	subHeading?: string;
	title: string;
	body: string;
	imgSrc: string;
	imgAlt: string;
	firstSection?: Queries.ParagraphSectionsDataFragment;
	withSearch?: boolean;
	isMaintenance?: boolean;
}

export const IntroToDisplay: React.FC<IntroProps> = ({
	introType,
	firstSection,
	...introProps
}) => {
	if (!introType) {
		// Adding noise to builds, turn on if needed
		// console.warn("IntroToDisplay: No introType received.");
		return null;
	}

	switch (introType) {
		case "Intro-Rehoming":
			return <IntroRehoming {...introProps} />;
		case "Intro-Hero-With-Image":
			return (
				<IntroHeroWithImage
					{...introProps}
					borderColour={getBorderColour({ data: firstSection })}
				/>
			);
		case "Intro-Hero-With-Image-Right":
			return (
				<IntroHeroWithImageRight
					{...introProps}
					borderColour={getBorderColour({ data: firstSection })}
				/>
			);
		case "Intro-Hero-With-Image-Teal":
			return (
				<IntroHeroWithImage
					{...introProps}
					backgroundColour={Colours.TEAL}
					borderColour={getBorderColour({ data: firstSection })}
				/>
			);
		case "Intro-Hero-With-Pre-Heading":
			return (
				<IntroHeroWithPreHeading
					{...introProps}
					borderColour={getBorderColour({ data: firstSection })}
				/>
			);
		case "Intro-Hero-With-Sub-Heading":
			return (
				<IntroHeroWithSubheading
					title={introProps.title}
					htmlSubHeading={introProps.body}
					borderBottomColor={getBorderColour({ data: firstSection })}
				/>
			);
		case "Intro-Hero-Left-Aligned":
			return (
				<IntroHeroLeftAligned
					{...introProps}
					title={introProps.title}
					htmlSubHeading={introProps.body}
					borderBottomColor={getBorderColour({ data: firstSection })}
				/>
			);
		case "Intro-Circle-Image-And-Search":
			return <IntroCircleImageAndSearch {...introProps} />;
		case "Intro-Sponsor-Dog-Search":
			return <IntroSponsorADogSearch {...introProps} />;
		case "Intro-With-Icons-Teal":
			return (
				<IntroWithImageTeal
					{...introProps}
					borderColour={getBorderColour({ data: firstSection })}
				/>
			);
		case "Intro-OurStories":
			return (
				<IntroOurStories
					title={introProps.title}
					htmlSubHeading={introProps.body}
					{...introProps}
				/>
			);
		default:
			return null;
	}
};

export default IntroToDisplay;
